import React, { useState } from 'react';
import { Plus, Check, X } from 'lucide-react';
import { Input } from './ui/input';
import { createCategory } from '../lib/categories';

// Botão "+" ao lado do seletor de categoria: abre campo inline para criar uma nova categoria.
export const NewCategoryButton = ({ onCreated, className = '' }) => {
  const [open, setOpen] = useState(false);
  const [label, setLabel] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const save = async () => {
    const name = label.trim();
    if (name.length < 2) { setError('Digite o nome da categoria'); return; }
    setBusy(true); setError('');
    try {
      const r = await createCategory(name);
      setLabel(''); setOpen(false);
      onCreated?.(r.value, r.label);
    } catch (e) {
      setError(e.response?.data?.detail || 'Erro ao criar categoria');
    } finally { setBusy(false); }
  };

  if (!open) {
    return (
      <button type="button" onClick={() => setOpen(true)} title="Nova categoria"
        className={`h-9 w-9 shrink-0 rounded-md border border-slate-300 bg-white text-blue-600 hover:bg-blue-50 hover:border-blue-400 flex items-center justify-center ${className}`}
        data-testid="new-category-btn">
        <Plus size={18} />
      </button>
    );
  }
  return (
    <div className={`flex flex-col gap-1 ${className}`} data-testid="new-category-form">
      <div className="flex items-center gap-1">
        <Input autoFocus value={label} onChange={(e) => setLabel(e.target.value)} placeholder="Nome da nova categoria" className="h-9 text-sm"
          onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); save(); } if (e.key === 'Escape') { setOpen(false); setLabel(''); } }}
          data-testid="new-category-input" />
        <button type="button" onClick={save} disabled={busy} title="Salvar categoria" className="h-9 w-9 shrink-0 rounded-md bg-blue-600 hover:bg-blue-700 text-white flex items-center justify-center" data-testid="new-category-save"><Check size={16} /></button>
        <button type="button" onClick={() => { setOpen(false); setLabel(''); setError(''); }} title="Cancelar" className="h-9 w-9 shrink-0 rounded-md border border-slate-300 text-slate-500 hover:bg-slate-100 flex items-center justify-center" data-testid="new-category-cancel"><X size={16} /></button>
      </div>
      {error && <p className="text-xs text-red-600" data-testid="new-category-error">{error}</p>}
    </div>
  );
};
